import type { DeepReadonly } from 'vue'
import { fetchJSON } from './utils'
import appDefault from '@/configs/app.config.json'
import simakatraDefault from '@/configs/simakatra.config.json'

type AppConfig = DeepReadonly<typeof appDefault>
type SimakatraConfig = DeepReadonly<typeof simakatraDefault>

export const appConfig = Object.assign(appDefault, await fetchJSON('/configs/app.config.json')) as AppConfig
export const simakatraConfig = Object.assign(simakatraDefault, await fetchJSON('/configs/simakatra.config.json')) as SimakatraConfig
